import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { Field } from "redux-form";
import {
  renderInput,
  RenderSelectForm,
  RenderMultipleAttractantString,
  RenderSelect
} from "../../../../../Forms/FormFields";
import { createFilterOptions } from "@mui/material/Autocomplete";
import ResponsiveButton from "../../../../../Forms/ResponsiveButton";
import { ATTRACTANT_OPTIONS, TRAP_TYPE_OPTIONS } from "../../../../../../utils/const";

const CollectionMethodForm = ({
  onSubmit,
  onDiscardChanges,
  possibleVectorTypes,
  handleSubmit,
  initialValues,
  change,
}) => {

  const vectorTypeOptions = Object.keys(possibleVectorTypes).map((key) => ({
    id: key,
    displayName: key,
  }));

  const [selectedVectorType, setSelectedVectorType] = useState("");
  const [selectedTrapType, setSelectedTrapType] = useState("");
  const [selectedAttractant, setSelectedAttractant] = useState([]);
  const [filteredTrapTypes, setFilteredTrapTypes] = useState([]);
  const [filteredAttractants, setFilteredAttractants] = useState([]);


  const handleVectorTypeChange = (event, newValue) => {
    const newVectorType = newValue !== undefined && newValue !== null ? newValue : event.target.value;
    setSelectedVectorType(newVectorType);
  };

  const handleTrapTypeChange = (event, newValue) => {
    const newTrapType = newValue !== undefined && newValue !== null ? newValue : event.target.value;
    setSelectedTrapType(newTrapType);
  };


  const handleAttractantChange = (event, newValue) => {
    const newAttractant = newValue !== undefined && newValue !== null ? newValue : event.target.value;
    setSelectedAttractant(newAttractant);
    // change("attractantType", newAttractant);
  };
  useEffect(() => {

    if (initialValues?.vectorType) {
      setSelectedVectorType(initialValues.vectorType);
    }

    const trapDoesNotExist = !TRAP_TYPE_OPTIONS.some(
      (option) => option.id === initialValues?.trapType
    );

    if (initialValues?.trapType && !trapDoesNotExist) {
      setSelectedTrapType(initialValues.trapType);
    } else if (initialValues?.trapType && trapDoesNotExist) {
      const otherTrapOption = TRAP_TYPE_OPTIONS.find(option => option.id === "Other");
      if (otherTrapOption) {
        setSelectedTrapType(otherTrapOption.id);
        change("trapType", otherTrapOption.id);
        change("otherTrapType", initialValues.trapType);
      }
    }
    // if (initialValues?.attractantType) {
    //   change("attractantType", initialValues.attractantType);
    // }
    //eslint-disable-next-line
  }, []);


  useEffect(() => {
    const filteredTraps = TRAP_TYPE_OPTIONS
      .filter((trap) => trap.targets.includes(selectedVectorType))
      .map(({ targets, ...rest }) => rest);

    setFilteredTrapTypes(filteredTraps);

    const filteredAttractants = ATTRACTANT_OPTIONS
      .filter((attractantType) => attractantType.targets.includes(selectedVectorType))
      .map(({ targets, ...rest }) => rest);

    // setFilteredAttractants(filteredAttractants);

    const attractantStrings = filteredAttractants.map((a) => a.displayName); // or .id
    setFilteredAttractants(attractantStrings);
  }, [selectedVectorType]);


  return (
    <form onSubmit={handleSubmit(onSubmit)} >
      <Box
        className={"flex flex-col p-6"}
        sx={{
          "& .MuiFormControl-root": {
            width: "100%",
            marginBottom: "1rem",
          },
          "& .MuiTextField-root": {
            marginBottom: "1rem",
          },
        }}
      >

        < Field
          name="displayName"
          component={renderInput}
          label="Display Name *"
        />


        <Field
          name="vectorType"
          component={RenderSelectForm}
          label="Vector Type *"
          options={vectorTypeOptions}
          getOptionLabel={(value) => {
            return (
              vectorTypeOptions?.find(
                (option) => option?.id === value
              )?.displayName || ""
            );
          }}
          onChange={handleVectorTypeChange}
          value={selectedVectorType}
        />

        <Field
          name={"trapType"}
          component={RenderSelect}
          label="Trap Type"
          options={filteredTrapTypes}
          getOptionLabel={(value) => {
            return (
              filteredTrapTypes?.find(
                (option) => option?.id === value
              )?.displayName || ""
            );
          }}
          isOptionEqualToValue={(option, value) => {
            return option?.id === value;
          }}
          value={selectedTrapType}
          onChange={handleTrapTypeChange}
          filterOptions={createFilterOptions({
            matchFrom: "any",
            stringify: (option) => option?.displayName,
          })}
        />

        {/* 
        <Field
          key="trapType"
          label="Collection Method"
          name="trapType"
          inputProps={{
            id: "trap-type-field",
            "data-testid": "collection-method",
          }}
          options={trapTypeAutoCompleteOptions || []}
          disabled={loading}
          component={RenderSelect}
          getOptionLabel={(value) => {
            return (
              trapTypeAutoCompleteOptions?.find(
                (option) => option?.id === value
              )?.displayName || ""
            );
          }}
          isOptionEqualToValue={(option, value) => {
            return option?.id === value;
          }}
          filterOptions={createFilterOptions({
            matchFrom: "any",
            stringify: (option) => option?.displayName,
          })}
        /> */}

        {/* If Other is selected  */}
        {selectedTrapType === "Other" && (
          <Box sx={{ marginBottom: "1rem" }}>
            <Field
              name="otherTrapType"
              component={renderInput}
              label="Other Trap Type"
            />
          </Box>
        )}

        <Field
          name="attractantType"
          component={RenderMultipleAttractantString}
          label="Attractant"
          options={filteredAttractants}
          getOptionLabel={(value) => {
            return (
              filteredAttractants?.find(
                (option) => option === value
              ) || ""
            );
          }}
          value={selectedAttractant}
          onChange={handleAttractantChange}
        />

        {selectedAttractant.includes("Other") && (
          <Box sx={{ marginBottom: "1rem" }}>
            <Field
              name="otherAttractantType"
              component={renderInput}
              label="Other Attractant"
            />
          </Box>
        )}


        <Field
          name="description"
          component={renderInput}
          label="Description"
        />



        <Box
          sx={{
            mt: ["0.75rem", "0.75rem", "0.75rem", "0.75rem", "1rem", "1rem"],
            mx: "auto",
            "& .MuiButton-root": {
              mx: "2rem",
            },
          }}
        >
          <ResponsiveButton id={"save-collection-method"} color="primary" type="submit">
            Save
          </ResponsiveButton>
          <ResponsiveButton
            id={"discard-collection-method-changes"}
            style={{ color: "#E10050" }}
            onClick={onDiscardChanges}
          >
            Cancel
          </ResponsiveButton>
        </Box>
      </Box>
    </form >
  );
};

export default CollectionMethodForm;
